import React from 'react'
import Button, { ButtonProps } from '@mui/material/Button'

let ButtonView: React.FC<ButtonProps> = ({ ...other }) => {
    return <Button {...other} variant="contained" />
}

let ButtonControl: React.FC<ButtonProps> = ({ ...others }) => {
    const styleCustom = { minWidth: '25px', ...others?.style } //original 125px
    return <ButtonView {...others} style={styleCustom} />
}

export default ButtonControl
